import { ActivityDetailSectionCardBaseLayout } from 'modules/components/layer16';
import React from 'react';
import { DateTime } from 'luxon';
import { MilestoneStatusName } from 'generated/graphql';
import { ClientReportItem } from 'modules/components/layer19';
import { ChipProps } from '@mui/material';
import * as ds from './dataService';


export type ClientReportMilestoneCardProps = {
  id: string;
  milestones: {
    id: string;
    updatedAt: DateTime;
    name: string;
    notesForClient: string;
    statusName: MilestoneStatusName;
    statusDisplayName: string;
    included: boolean;
  }[];
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ClientReportMilestoneCardProps) => {
  const [fnSaveMetaMilestone] = ds.useSaveClientReportMetaMilestone();
  return (
    <ActivityDetailSectionCardBaseLayout.FC
      title='Milestone Updates'
      subTitle='Review Milestones that have changed since the last Client Report.'
      actionButton={null}
      editActionButton={null}
    >{
        props.milestones.map((node) => (
          <ClientReportItem.FC
            key={node.id}
            imageRow={null}
            id={node.id}
            handleInclude={() => fnSaveMetaMilestone({
              id: node.id, included: !node.included
            })}
            clientNotes={node.notesForClient}
            title={node.name}
            included={node.included}
            status={{
              variant: node.statusDisplayName as ChipProps['variant'],
              label: node.statusDisplayName
            }}
            secondaryBox={{
              label: 'Updated On',
              value: node.updatedAt.toFormat('DDDD')
            }}
            reportItemType='MILESTONE'
          />
        ))
      }

    </ActivityDetailSectionCardBaseLayout.FC>
  );
};
